import type { FormField } from '@cli-types/core-engine/schema.js'
import { escapeAttribute, jsString } from '@cli-utils/text.js'
import { renderNumberFieldJsxFieldControllerTemplate } from '@next-adapter/templates/renderers/generators/form-pipeline/form-component-shared/generate-number-field-jsx.js'
import { errorMessageLine } from './error-message-line.js'
import { fieldContainerClass } from './field-container-class.js'
import { formLabelWithDescriptionLine } from './form-label-with-description-line.js'
import { inputClass } from './input-class.js'

export function generateNumberFieldJSX(
  name: string,
  label: string,
  placeholder: string,
  hintJSX: string,
  requiredStar: string,
  height?: FormField['height']
): string {
  return renderNumberFieldJsxFieldControllerTemplate({
    name: name,
    fieldContainerClass: fieldContainerClass(height),
    formLabelWithDescriptionLine: formLabelWithDescriptionLine(
      name,
      label,
      requiredStar,
      hintJSX,
      '              '
    ),
    escapeAttribute: escapeAttribute(placeholder),
    inputClass: inputClass(height),
    errorMessageLine: errorMessageLine(jsString(name), '              ')
  })
}
